import React, { memo } from 'react';

import { SharedButtonProps } from '../../types/SharedButtonProps';
import { Box } from '../Box/Box';
import { Button } from '../Button/Button';
import { Image } from '../Image/Image';
import { Layout } from '../Layout/Layout';
import { Text } from '../Text/Text';
import { PresetKey } from './types';
import { usePreset } from './usePreset';

interface Props {
  /** Empty page preset */
  preset: PresetKey;
  /** CTA action for resolving the empty state */
  resolveAction?: SharedButtonProps;
}

export const EmptyPage = memo(({ preset, resolveAction }: Props) => {
  const { description, image, imageAlt, title } = usePreset(preset);

  return (
    <Layout
      align="center"
      direction="column"
      h="100%"
      justify="center"
      minW="min-content"
      p={12}
      spacing={4}
      w="100%"
    >
      {image && <Image alt={imageAlt} image={image} />}
      <Text textAlign="center" variant="subtitle">
        {title}
      </Text>
      <Text color="text.secondary" textAlign="center">
        {description}
      </Text>
      {resolveAction && (
        <Box pt={8}>
          <Button {...resolveAction} variant="primary" />
        </Box>
      )}
    </Layout>
  );
});
